import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

interface Props {
  /** Changing this resets the boundary — a new compile deserves a new try. */
  resetKey: unknown
  onError: (message: string) => void
  children: ReactNode
}

interface State {
  failed: boolean
}

/**
 * Catches a throw from inside an example's render. Without this one bad edit
 * unmounts the whole site, which is precisely the failure the FRD forbids.
 */
export class ExampleErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.failed) {
      this.setState({ failed: false })
    }
  }

  componentDidCatch(error: Error, _info: ErrorInfo) {
    this.props.onError(error.message)
  }

  render() {
    return this.state.failed ? null : this.props.children
  }
}
